// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@adl/XDL/Utilities";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { css } from "styled-components";

interface FormFieldErrorProps {
    errorText?: string;
    extendedStyles?: FormFieldErrorStyles;
}

export interface FormFieldErrorStyles {
    errorText?: TypographyPresentationProps;
}

export const formFieldErrorStylesStyles: FormFieldErrorStyles = {
    errorText: {
        size: 12,
        weight: "normal",
        color: "danger",
        css: css`
            letter-spacing: 0;
            line-height: 13px;
            margin-top: 8px;
        `,
    },
};

const FormFieldError = ({ errorText, extendedStyles }: FormFieldErrorProps) => {
    const [styles] = useState(() => mergeWithCss(formFieldErrorStylesStyles, extendedStyles));

    if (!errorText) {
        return null;
    }

    return <Typography {...styles.errorText}>{errorText}</Typography>;
};

export default FormFieldError;
